// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResultRow-cls1__c836d7125c5bf5e0f861","cls2":"AutoCompleteResultRow-cls2___639e41f9f5b52880ad8 AutoCompleteResultRow-cls1__c836d7125c5bf5e0f861"};